<div style="text-align:center">
  <h1>
  {{ title }}
  </h1>
  <p>Test importing via lerna: {{ lernaTest }}</p>

  <app-translation-sample></app-translation-sample>
  <app-sw-update-prompt></app-sw-update-prompt>
  <app-api-sample></app-api-sample>

</div>
